import script from "./ChangeBlacklistStateModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeBlacklistStateModal.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeBlacklistStateModal.vue?vue&type=style&index=0&id=92f9d12c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92f9d12c"]])

export default __exports__